<mat-form-field class='mxs-input' *ngIf="!formReadonlyMode"
                [formGroup]="form"
                [ngClass]="{'hidden': hidden}"
                [matTooltip]="getValidationHint() | translate"
                [matTooltipClass]="'mxs-error-ttip'">
    <mat-label>{{getLabel() | translate}}</mat-label>
    <input matInput
           mxNumericInput
           [positiveInteger]="positiveInteger"
           (click)="defaultClickHandler()"
           [name]="name"
           [value]="getValue()"
           [errorStateMatcher]=errorService
           [formControlName]="name"
           [readonly]=readonly
           [required]="required"
    />

    <button *ngIf="isDisplayed()" matSuffix mat-icon-button type="button" aria-label="Clear"
            (click)="resetValue($event)">
        <mat-icon>clear</mat-icon>
    </button>
    <button *ngIf="withIcon()" matSuffix mat-icon-button type="button"
            (click)="defaultClickHandler()">
        <mat-icon>{{withIcon()}}</mat-icon>
    </button>
    <mat-hint>{{getHint() | translate}}</mat-hint>
    <mat-error *ngFor="let error of getValidationMessages(true)">
        {{getError(error) | translate}}
    </mat-error>
</mat-form-field>

<mat-list-item class="mxs-readonly" *ngIf="formReadonlyMode"
               [ngClass]="{'hidden': hidden}">
    <div class="mxs-readonly_label">{{getLabel() | translate}}</div>
    <div class="mxs-readonly_input">{{getDisplayValue(form.get([name]).value)}}</div>
</mat-list-item>
